var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "feedback-stars__wrapper" }, [
    _c(
      "a",
      {
        staticClass: "feedback-stars__amount",
        attrs: { href: "#" },
        on: {
          click: function ($event) {
            $event.preventDefault()
          },
        },
      },
      [
        _vm._v(
          "\n        " +
            _vm._s(_vm.counts.ratingsCountTotal) +
            " " +
            _vm._s(_vm.$translate("OD3dprimaV2::Template.ratings")) +
            "  \n    "
        ),
      ]
    ),
    _vm._v(" "),
    _vm.showEmptyRatings || _vm.counts.averageValue > 0
      ? _c("div", { staticClass: "feedback-stars-average", class: _vm.size }, [
          _c(
            "div",
            { staticClass: "feedback-stars-background clearfix" },
            _vm._l(5, function (index) {
              return _c("div", { staticClass: "feedback-star" }, [
                _c("i", { staticClass: "fa fa-star" }),
              ])
            }),
            0
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "feedback-stars-overlay-wrap",
              style: { width: _vm.fill },
            },
            [
              _c(
                "div",
                { staticClass: "feedback-stars-overlay clearfix" },
                _vm._l(5, function (index) {
                  return _c("div", { staticClass: "feedback-star" }, [
                    _c("i", { staticClass: "fa fa-star" }),
                  ])
                }),
                0
              ),
            ]
          ),
        ])
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }